"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("@material-ui/core");
var urls_1 = __importDefault(require("../../app/urls"));
var patientConsentService_1 = require("../../app/services/patientConsentService");
var components_1 = require("../../common/components");
var breadcrumbUtil_1 = require("../../common/breadcrumbUtil");
var translate_1 = __importDefault(require("../../app/localization/translate"));
var store_1 = require("../../app/store");
var components_2 = require("../../youwell-common/components");
var icons_1 = require("../../youwell-common/icons");
var useStyles = (0, core_1.makeStyles)(function (theme) { return (0, core_1.createStyles)({
    main: {},
    consents: {
        margin: theme.spacing(2, 0),
    },
    consentList: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        background: theme.palette.common.white,
    },
    greenIcon: {
        color: theme.youwell.colors.green,
    },
    consent: {
        padding: theme.spacing(2),
        background: theme.palette.common.white,
    },
    actions: {
        marginTop: theme.spacing(8),
        borderTop: theme.youwell.borders.dim,
        padding: theme.spacing(4),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    consentCheckBox: {
        marginRight: theme.spacing(4),
    },
    sendButton: {
        minWidht: 100,
    },
    radioGroup: {},
    radio: {},
}); });
var Consent = function () {
    var classes = useStyles();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var consentId = (0, react_router_1.useParams)().consentId;
    var translate = (0, translate_1.default)();
    var clientConfig = (0, store_1.useYouwellSelector)(function (state) { return state.auth.clientConfig; });
    var patientConsents = (0, store_1.useYouwellSelector)(function (state) { var _a; return (_a = state.auth.profileData) === null || _a === void 0 ? void 0 : _a.patientConsents; });
    var selectedConsent = consentId ? patientConsents === null || patientConsents === void 0 ? void 0 : patientConsents.find(function (c) { return c.id === Number(consentId); }) : (patientConsents === null || patientConsents === void 0 ? void 0 : patientConsents.length) === 1 ? patientConsents[0] : patientConsents === null || patientConsents === void 0 ? void 0 : patientConsents.find(function (c) { return !c.consentDate; });
    var selectedConsentTask = (0, store_1.useYouwellSelector)(function (state) { var _a; return (selectedConsent ? (_a = state.patientConsentStore.taskDetails) === null || _a === void 0 ? void 0 : _a[selectedConsent.consentTaskId] : null); });
    var _a = React.useState(null), consentChecked = _a[0], setConsentChecked = _a[1];
    var hasUnansweredConsents = (0, store_1.useYouwellSelector)(function (state) { return state.auth.hasUnansweredConsents; });
    var sendResponse = function () {
        if (selectedConsent) {
            var response = {
                consentId: selectedConsent.id,
                consentTaskVersion: selectedConsentTask === null || selectedConsentTask === void 0 ? void 0 : selectedConsentTask.version,
                accept: !!consentChecked,
            };
            var redirect = hasUnansweredConsents ? urls_1.default.inside.home : undefined;
            (0, patientConsentService_1.submitConsents)(dispatch, response, { callback: function () { return setConsentChecked(null); }, redirect: redirect });
        }
    };
    React.useEffect(function () {
        if (selectedConsent && !selectedConsentTask) {
            (0, patientConsentService_1.fetchConsentTaskDetails)(dispatch, selectedConsent.consentTaskId);
        }
    }, [dispatch, selectedConsent, selectedConsentTask]);
    return (React.createElement(components_1.PageLayout
    // title={translate('consentPage.consent')}
    , { 
        // title={translate('consentPage.consent')}
        breadcrumb: (0, breadcrumbUtil_1.getBreadCrumb)(translate('consentPage.consent'), translate, clientConfig) },
        React.createElement("div", { className: classes.main }, patientConsents && patientConsents.length > 1 && (React.createElement("div", { className: classes.consents },
            React.createElement(core_1.Typography, { variant: "subtitle1", color: "primary" }, translate(hasUnansweredConsents ? 'consentPage.youHaveRequiredConsents' : 'consentPage.yourConsents')),
            React.createElement(core_1.List, { className: classes.consentList }, patientConsents.map(function (c) { return (React.createElement(core_1.ListItem, { key: c.id, button: true, component: react_router_dom_1.Link, to: "".concat(urls_1.default.inside.pages.consent, "/").concat(c.id), selected: Boolean(selectedConsent && c.id === selectedConsent.id) },
                React.createElement(core_1.ListItemIcon, null, c.consent ? React.createElement(icons_1.CheckedIcon, { className: classes.greenIcon }) : React.createElement(icons_1.UncheckedIcon, null)),
                React.createElement(core_1.ListItemText, { primary: c.consentName }))); }))))),
        selectedConsent && selectedConsentTask && (React.createElement("div", { className: classes.consent },
            React.createElement(components_2.TaskContentDisplay, { task: selectedConsentTask }),
            React.createElement("div", { className: classes.actions },
                React.createElement(core_1.RadioGroup, { className: classes.radioGroup, onChange: function (_e, value) { return setConsentChecked(value === 'true'); } },
                    React.createElement(core_1.FormControlLabel, { className: classes.radio, value: "true", control: React.createElement(core_1.Radio, { checked: consentChecked === null ? selectedConsent.consent : consentChecked }), label: translate('consentPage.yesIConsent') }),
                    React.createElement(core_1.FormControlLabel, { className: classes.radio, value: "false", control: React.createElement(core_1.Radio, { checked: !(consentChecked === null ? selectedConsent.consent : consentChecked) }), label: translate('consentPage.noIDontConsent') })),
                React.createElement(core_1.Button, { onClick: sendResponse, variant: "contained", color: "primary", disabled: selectedConsent.consentDate && consentChecked === null, className: classes.sendButton }, translate(selectedConsent.consentDate ? 'consentPage.update' : 'consentPage.send')))))));
};
exports.default = Consent;
